(function ($) {
    $(function () {
        /**
         * Format a telephone number to include a space after the 5th character
         *
         * @return void
         */
        const formatTelephone = function(event) {
            // Get value
            let telephone = this.value;

            // Replace multiple whitespace with one, and trim leading and ending
            // whitespace
            let trimmedTelephone = telephone.replace(/\s/g, '');

            // If the length of the trimmed phone is 11 and no whitespace exists already
            if (trimmedTelephone.length >= 11) {
                this.value = trimmedTelephone.substring(0, 5) + ' ' + trimmedTelephone.substring(5);
            }
        }

        // Attach postcode formatting handler
        const inputs = [
            '#shipping_phone',
            '#shipping_mobile',
            '#billing_phone',
            '#billing_mobile',
        ];

        inputs.forEach((selector) => {
            const inputs = document.querySelectorAll(selector);

            inputs.forEach((input) => {
                if (input !== null) {
                    // We must bind with jQuery so that when Woo triggers events
                    // via jQuery, these run too
                    $(input).on('change', formatTelephone);
                }
            });
        });
    });
})(jQuery);
